import React from "react"
import Box from "../Box"
import Container from "../Container"
import Flex from "../Flex"
import Absolute from "../Absolute"
import Relative from "../Relative"
import { func, string } from "prop-types"
import system from "system-components"
import searchIcon from "../../images/ic-search.svg"
import Image from "../Image"

const Input = system(
  {
    is: "input",
    type: "text",
    w: 1,
    fontSize: 2,
    color: "Ink Dark",
    lineHeight: "none",
    border: 0,
    placeholder: "",
    pl: 32,
  },
  props => ({
    fontFamily: "inherit",
    appearance: "none",
    outline: 0,

    "&::placeholder": {
      color: "Ink Lighter",
    },
    "::-webkit-search-decoration": {
      display: "none",
    },
  })
)

function SearchBar({ value, placeholder, label, onChange, ...props }) {
  return (
    <Box py={5} mb={4} bg="white">
      <Container>
        <Relative {...props}>
          <Absolute>
            <Flex alignItems="center" height="100%">
              <Image src={searchIcon} width={20} alt="Search Icon" />
            </Flex>
          </Absolute>
        </Relative>
        <Input
          type="search"
          value={value}
          placeholder={placeholder}
          aria-label={label}
          onChange={onChange}
        />
      </Container>
    </Box>
  )
}

SearchBar.propTypes = {
  value: string,
  placeholder: string,
  label: string,
  onChange: func,
}

SearchBar.defaultProps = {
  value: "",
  placeholder: "",
  label: "",
  onChange: () => {},
  onFocus: () => {},
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/colorfinder/SearchBar.js